import { fetchProductInMarketResearch } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ProductInMarketResearchKeys = {
    all: ['productinmarketresearch'] as const,
    lists: () => [...ProductInMarketResearchKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ProductInMarketResearchKeys.lists(), page, perPage, filters] as const,
    details: () => [...ProductInMarketResearchKeys.all, 'detail'] as const,
    detail: (params: number) => [...ProductInMarketResearchKeys.details(), params] as const,
}

export const useProductInMarketResearchQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchProductInMarketResearch(SK_PESQUISA),
        queryKey: ProductInMarketResearchKeys.detail(SK_PESQUISA),
    })
}
